export default {"src":"/_next/static/media/choco-logo.19021cae.svg","height":90,"width":110};